import UnAuthorizedException from '../../../common/exeptions/UnAuthorizedException.ts';
import { axiosInstance } from '../../../common/axiosInstans.ts';

class SignService {
    async signWithCredentials({
        emailOrUserName,
        password,
    }: {
        emailOrUserName: string;
        password: string;
    }) {
        const isEmail = emailOrUserName.includes('@');
        let url = '';
        let requestBody = {};

        if (isEmail) {
            url = '/signing/email';
            requestBody = { email: emailOrUserName, password };
        } else {
            url = '/signing/username';
            requestBody = { username: emailOrUserName, password };
        }

        try {
            const response = await axiosInstance.post(url, requestBody, {
                skipAuthRedirect: true, // Don't logout user on 401 from signing endpoints
            });
            return response.data;
        } catch (error) {
            console.error('Error during API call:', error.message);
            // Handle 401 errors from signing endpoints
            if (error.response && error.response.status === 401) {
                throw new UnAuthorizedException(
                    'Username and password is not matching',
                    401
                );
            }
            // Re-throw other errors
            throw error;
        }
    }
}

export default new SignService();
